import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AssetDao } from '@app/dao/asset/asset.dao';
import { LoanDao } from '@app/dao/loan/loan.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-general-informations',
    templateUrl: './credit-general-informations.component.html',
    styleUrls: ['./credit-general-informations.component.scss'],
    standalone: false
})
export class CreditGeneralInformationsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  loansCategoriesRefs: any[] = [];
  agencesBancaires: any[] = [];
  agencesBancairesFiltered: any[] = [];
  providers: any[] = [];
  owners: any[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
    private loanDao: LoanDao,
    private assetDao: AssetDao,
    private userDao: UserDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    combineLatest([
      this.loanDao.getReferences(),
      this.assetDao.getProviders({
        productType: 'LOAN',
        size: -1,
        page: 1,
      }),
      this.assetDao.getAgencesBancaires(),
      this.userDao.getOwners(),
    ]).subscribe(([references, providers, agencesBancaires, owners]) => {
      this.loansCategoriesRefs = references?.categories;
      this.providers = providers.filter(provider => provider.externalId);
      this.agencesBancaires = agencesBancaires;
      this.owners = owners;

      const providerId = this.form
        .get('products')
        .get('0')
        .get('parameters')
        .get('loan')
        .get('providerId').value;
      if (providerId) {
        this.agencesBancairesFiltered = agencesBancaires.filter(
          agence => agence.providerId === providerId,
        );
      } else {
        this.agencesBancairesFiltered = agencesBancaires;
      }
    });
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.setCommand([]);
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  onBanqueChange(value) {
    this.agencesBancairesFiltered = this.agencesBancaires.filter(
      agence => agence.providerId === value,
    );
    this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('loan')
      .get('agenceBancaireId')
      .setValue(null);
    this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('loan')
      .get('agenceBancaireId')
      .updateValueAndValidity();
  }

  displayAgenceBancaire(option: any): string {
    return `${option.codeGuichet} - ${option.ville}`;
  }
}
